import React from 'react';
import { Link } from 'react-router-dom';

const EdgeInfotech: React.FC = () => {
  return (
    <div className="edge-infotech-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">EDGE INFOTECH</h1>
          <p className="text-white text-xl mb-4 animate-fadeInUp">Skill Development Services</p>
          <p className="text-secondary text-lg animate-fadeInUp">A Unit of NEXEDZ PRIVATE LIMITED</p>
          <nav className="flex justify-center animate-fadeInUp mt-4">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/education" className="hover:text-secondary">Education</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">EDGE INFOTECH</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-6">Building Skills. Building Careers. Building Bharat.</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                EDGE INFOTECH focuses on transforming youth into skilled professionals and entrepreneurs through high-quality, job-oriented training programs. At Edge Infotech, we believe that real progress begins with the right skills.
              </p>
            </div>

            <div className="bg-gradient-to-r from-primary to-secondary text-white p-8 rounded-lg shadow-lg mb-12 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <h3 className="text-2xl font-bold mb-4 text-center">Our Vision</h3>
              <p className="text-lg leading-relaxed text-center">
                As one of Bharat's emerging leaders in skill development and professional training, we are committed to empowering students, youth, and working professionals with the competencies they need to succeed in a fast-changing world.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-md animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
              <p className="text-gray-700 text-lg leading-relaxed text-center">
                Our programs are designed to bridge the gap between education and industry, ensuring every learner becomes <strong>job-ready, confident, and future-focused</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">Key Services</h2>
              <p className="text-gray-600 text-lg">
                Comprehensive skill development solutions for modern Bharat
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service 1 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-graduation-cap text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Vocational Training Programs</h4>
                <p className="text-gray-600 text-center mb-4">
                  Certified skill courses designed for industry readiness
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Computer Education</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Fashion Designing</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Beauty & Wellness</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Retail Management</span>
                  </li>
                </ul>
              </div>

              {/* Service 2 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-laptop text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Digital Learning Solutions</h4>
                <p className="text-gray-600 text-center mb-4">
                  Modern education delivery for the digital age
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Online Classes</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Blended Learning Systems</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Self-Paced Learning</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>24/7 Content Access</span>
                  </li>
                </ul>
              </div>

              {/* Service 3 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lightbulb text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Entrepreneurship Development</h4>
                <p className="text-gray-600 text-center mb-4">
                  Support for aspiring entrepreneurs
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Business Guidance</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Startup Support</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Mentorship Programs</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Venture Building</span>
                  </li>
                </ul>
              </div>

              {/* Service 4 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-handshake text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Industry Partnership Programs</h4>
                <p className="text-gray-600 text-center mb-4">
                  Connecting learners with opportunities
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Industry Collaboration</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Internship Opportunities</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Placement Support</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>On-the-Job Training</span>
                  </li>
                </ul>
              </div>

              {/* Service 5 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp md:col-span-2 lg:col-span-1" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-building text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Skill Academy Establishment</h4>
                <p className="text-gray-600 text-center mb-4">
                  Expanding reach across Bharat
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Authorized Training Centres</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Pan-India Network</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Skill India Aligned</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check text-secondary mr-2 mt-1"></i>
                    <span>Self-Reliant Bharat Vision</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">What We Offer</h2>
            </div>

            <div className="space-y-8">
              {/* Offer 1 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp">
                <div className="flex items-start space-x-6">
                  <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-industry text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Industry-Oriented Training Programs</h3>
                    <p className="text-gray-600 mb-4">
                      We provide skill courses that are aligned with real market needs. Our training covers a wide range of high-demand sectors, including:
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Information Technology</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Retail & Sales</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Banking & Finance</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Hospitality</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Digital Skills</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Communication & Personality</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Offer 2 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="flex items-start space-x-6">
                  <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-hands-helping text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Practical & Hands-On Learning</h3>
                    <p className="text-gray-600 mb-4">
                      Our focus is not just on theory but on real-world application. Edge Infotech ensures:
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Live practical sessions</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Projects & assignments</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Case studies</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Internship & work-based learning</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Offer 3 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="flex items-start space-x-6">
                  <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-certificate text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Certified Courses</h3>
                    <p className="text-gray-600">
                      All programs are backed by industry-recognized certifications, boosting learners' credibility and employability.
                    </p>
                  </div>
                </div>
              </div>

              {/* Offer 4 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="flex items-start space-x-6">
                  <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-globe text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Digital Learning for Everyone</h3>
                    <p className="text-gray-600 mb-4">
                      Skill education should be accessible to all. Our digital platform enables:
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Online classes</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Self-paced learning</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">24/7 content access</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Assessments & progress tracking</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Offer 5 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                <div className="flex items-start space-x-6">
                  <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-briefcase text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">Placement & Career Support</h3>
                    <p className="text-gray-600 mb-4">
                      We ensure that learning leads to livelihood:
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Placement Assistance</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Resume Building</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Interview Preparation</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Soft Skills Enhancement</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">Our Approach</h2>
              <p className="text-gray-600 text-lg">
                Edge Infotech follows a learner-centric approach grounded in:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lightbulb text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Innovation</h4>
                <p className="text-gray-600">
                  Cutting-edge methods and technologies
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-award text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Quality Education</h4>
                <p className="text-gray-600">
                  Excellence in every training program
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-handshake text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Industry Collaboration</h4>
                <p className="text-gray-600">
                  Strong partnerships with businesses
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-chart-line text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Continuous Improvement</h4>
                <p className="text-gray-600">
                  Always evolving with market needs
                </p>
              </div>
            </div>

            <div className="mt-12 text-center animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              <p className="text-gray-700 text-lg">
                This ensures that every student receives the best training experience and becomes ready for career opportunities across Bharat.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">Why Choose Edge Infotech?</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="flex items-start space-x-4 animate-fadeInUp">
                <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-building text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Modern Training Infrastructure</h4>
                  <p className="text-gray-600">
                    State-of-the-art facilities and equipment
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-chalkboard-teacher text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Experienced & Certified Trainers</h4>
                  <p className="text-gray-600">
                    Learn from industry experts
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-briefcase text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Job-Oriented Curriculum</h4>
                  <p className="text-gray-600">
                    Courses designed for employment
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-money-bill-wave text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Affordable & Accessible Education</h4>
                  <p className="text-gray-600">
                    Quality training at reasonable prices
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-network-wired text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Strong Industry Partnerships</h4>
                  <p className="text-gray-600">
                    Direct connections to employers
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
                <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-map-marked-alt text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Pan-India Presence</h4>
                  <p className="text-gray-600">
                    Training centers across Bharat
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary to-secondary">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6 animate-fadeInUp">
            At Edge Infotech, we don't just train—we transform.
          </h2>
          <p className="text-white text-xl mb-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Join us to unlock your potential and step confidently into a future full of opportunities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/contact"
              className="bg-white text-primary hover:bg-gray-100 font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Enroll Now
            </Link>
            <Link
              to="/contact"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Request Information
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EdgeInfotech;